import React from "react";
import HomeScreen from "./Screens/HomeScreen";
import MenuScreen from "./Screens/MenuScreen";
import URLScreen from "./Screens/URLScreen";
import { useAppSelector } from "../../../Redux/hooks";

const CustomizationBody: React.FC = () => {
  const selectedCategory = useAppSelector(
    (state) => state.appCustomization.category
  );
  switch (selectedCategory) {
    case "home":
      return <HomeScreen />;
    case "menu":
      return <MenuScreen />;
    case "urls":
      return <URLScreen />;
    default:
      return <HomeScreen />;
  }
};

export default CustomizationBody;
